import { render, staticRenderFns } from "./MetadadosContainerLayout.vue?vue&type=template&id=49678a0a&"
import script from "./MetadadosContainerLayout.vue?vue&type=script&lang=js&"
export * from "./MetadadosContainerLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/metadados/MetadadosContainerLayout.vue
// module id = 1316
// module chunks = 28